module.exports = __webpack_public_path__ + "img/tabicon_2.99be56fb.png";